<template>
    <div class="agri-platform-container">
        <div class="top-title">
            <h2>网纹瓜全产业链数智管理平台</h2>
        </div>
        <!-- 主体内容区域 -->
        <el-row :gutter="16" class="main-content">
            <!-- 左侧：数字农业智能驾驶舱 -->
            <el-col :span="11">
                <img :src="dashboardImg" alt="数字农业智能驾驶舱" class="main-img">
            </el-col>

            <!-- 右侧：平台描述 -->
            <el-col :span="13">
                <div class="desc-card">
                    <p>
                        我公司基于现代农业管理需求，自主研发数字农业智能驾驶舱系统，为园区管理者提供全方位的数据监测与决策支持。该系统集成大棚环境监测（温度、湿度、光照等）、室外气象数据、设备运行状态等关键指标，实现农业生产的可视化、数字化管理。
                    </p>
                    <p>
                        平台支持远程控制灌溉、通风、遮阳等设备，确保作物生长环境精准调控。同时，系统自动记录农事作业执行情况，实现生产流程标准化管理与追溯。通过多维数据分析，平台可生成生产趋势报告，辅助管理者优化种植方案，提高资源利用效率，降低运营成本。
                    </p>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
export default {
    name: 'AgriPlatformPage',
    data() {
        return {
            dashboardImg: require('@/assets/images/Mainsoftware/wwg.png')

        }
    }
}
</script>